import ServerApi from "./../../../libs/api-services/server-api"

class StreetService extends ServerApi {
  URL_PREFIX = "/v1/secure/user/streets/"
}

export const streetService = new StreetService()
